import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { ICanShowSeeMore, searchType } from '../header-new/header-new.component';

@Component({
    selector: 'app-search-component',
    templateUrl: './search-component.component.html',
    styleUrls: ['./search-component.component.scss'],
    standalone: false
})
export class SearchComponentComponent implements OnInit {
    @Input() loader: boolean;
    @Input() searchData;
    @Input() searchKey;
    public marketPlaceUrl = environment.MARKETPLACE_URL;
    public isRegulated: boolean;
    @Output() resetSearch = new EventEmitter();
    @Output() seeMoreEmitter = new EventEmitter();
    searchType = searchType;
    // Loading states for different sections
    @Input() loadingStates = {
        log: false,
        collection: false,
        nft: false,
        user: false,
        holding: false,
    };
    @Input() canShowSeeMore:ICanShowSeeMore;

    constructor(private storageService: StorageService) {

    }

    /**
       * on init component
       */
    public ngOnInit(): void {
        this.isRegulated = JSON.parse(this.storageService.getItemSession('isRegulated'));
    }
    /**
     * Clicks reset search
     */
    clickResetSearch() {
        this.resetSearch.emit();
    }

    /**
     * Safely splits and highlights search matching text case-insensitively.
     * @param fString - Full text to highlight.
     * @param bString - Substring/query to search and highlight.
     * @returns An array of text segments marked as bold (matched) or not.
     */
    getHighlightParts(fString: string, bString: string): Array<{ text: string; bold: boolean }> {
        if (!fString) return [];
        const fullStr = fString.toString();
        if (!bString) {
            return [{ text: fullStr, bold: false }];
        }
        const searchStr = bString.toString().trim();
        if (!searchStr) {
            return [{ text: fullStr, bold: false }];
        }

        const parts: Array<{ text: string; bold: boolean }> = [];
        const regex = new RegExp(`(${this.escapeRegExp(searchStr)})`, 'gi');
        const splitParts = fullStr.split(regex);

        for (const part of splitParts) {
            if (part) {
                const isMatch = part.toLowerCase() === searchStr.toLowerCase();
                parts.push({ text: part, bold: isMatch });
            }
        }
        return parts;
    }

    private escapeRegExp(string: string): string {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    /**
     * Handles the "See More" button click for a specific section.
     * @param {keyof typeof this.loadingStates} type - The section type (e.g., 'log', 'collection', 'nft') to load more data for.
     */
    handleSeeMore(type: keyof typeof this.loadingStates): void {
        this.loadingStates[type] = true;
        this.seeMoreEmitter.emit(type);
    }

}
